import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.20568 15.9017C2.05005 14.5435 2 13.4672 2 11.9906C2 10.514 2.05005 9.43782 2.20568 8.07961C2.41849 6.22248 3.33916 5.28393 5.00686 5.17598C6.60161 5.07276 9.00027 5 11.9973 5C14.9944 5 17.393 5.07276 18.9878 5.17598C20.6555 5.28393 21.5762 6.22248 21.789 8.07961C21.9446 9.43782 21.9947 10.514 21.9947 11.9906C21.9947 13.4672 21.9446 14.5435 21.789 15.9017C21.5762 17.7588 20.6555 18.6973 18.9878 18.8053C17.393 18.9085 14.9944 18.9813 11.9973 18.9813C9.00027 18.9813 6.60161 18.9085 5.00686 18.8053C3.33916 18.6973 2.41849 17.7588 2.20568 15.9017ZM10 9.00001L16 12L10 15V9.00001Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(Youtube);
